import { buildServices } from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import {
  adaptLabsToStore,
  adaptLabToApi,
  adaptLabToStore,
  adaptLabsCategoriesToStore,
  adaptObjectiveToApi,
  adaptObjectiveToStore,
  adaptObjectivesToStore,
} from './adapters/labAdapter'
import { CONTENT } from '@/services/axios.config'

const normalizeIds = (ids) => (Array.isArray(ids) ? ids.join(',') : ids)

const services = [
  {
    name: 'listLabs',
    method: 'get',
    url: (params) => `/labs${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptLabsToStore,
  },
  {
    name: 'searchLabsByIds',
    method: 'post',
    url: () => `/labs/search`,
    data: (params = {}) => {
      const payload = {
        ids: normalizeIds(params.ids),
      }
      if (params.fields) {
        payload.fields = params.fields
      }
      return payload
    },
    params: (params = {}) => {
      const { ids, fields, ...query } = params
      return omitBy(query, isEmpty)
    },
    resolver: adaptLabsToStore,
  },
  {
    name: 'getLab',
    method: 'get',
    url: (params) => `/labs/${params.labId}`,
    resolver: adaptLabToStore,
  },
  {
    name: 'createLab',
    method: 'post',
    url: () => `/labs`,
    data: (params) => {
      return adaptLabToApi(params)
    },
    resolver: adaptLabToStore,
  },
  {
    name: 'editLab',
    method: 'patch',
    url: (params) => `/labs/${params.labId}`,
    data: (params) => {
      return adaptLabToApi(params)
    },
    resolver: adaptLabToStore,
  },
  {
    name: 'fetchObjectives',
    method: 'get',
    url: (params) => `/labs/${params.labId}/objectives`,
    resolver: adaptObjectivesToStore,
  },
  {
    name: 'createObjective',
    method: 'post',
    url: (params) => `/labs/${params.lab}/objectives`,
    data: (params) => {
      return adaptObjectiveToApi(params)
    },
    resolver: adaptObjectiveToStore,
  },
  {
    name: 'updateObjective',
    method: 'put',
    url: (params) => `/labs/${params.lab}/objectives/${params.id}`,
    data: (params) => {
      return adaptObjectiveToApi(params)
    },
    resolver: adaptObjectiveToStore,
  },
  {
    name: 'deleteObjective',
    method: 'delete',
    url: (params) => `/labs/${params.lab}/objectives/${params.id}`,
    data: (params) => {
      return adaptObjectiveToApi(params)
    },
    resolver: adaptObjectiveToStore,
  },
  {
    name: 'listLabsCategories',
    method: 'get',
    url: (params) => `/lab-categories${buildParamList(params)}`,
    resolver: adaptLabsCategoriesToStore,
  },
  {
    name: 'getLabsCategory',
    method: 'get',
    url: (params) => `/lab-categories/${params.categoryId}`,
  },
]

export const {
  listLabs,
  searchLabsByIds,
  getLab,
  createLab,
  editLab,
  fetchObjectives,
  createObjective,
  updateObjective,
  deleteObjective,
  listLabsCategories,
  getLabsCategory,
} = buildServices(CONTENT, services)
